import type { GridFilterOperator } from '@mui/x-data-grid-premium';
import { getGridDateOperators } from '@mui/x-data-grid-premium';

import { DateFilterInput } from './DateFilterInput';

// MUI's date operators with DateFilterInput in place of GridFilterInputDate.
export const dateFilterOperators: GridFilterOperator[] = getGridDateOperators().map(operator =>
  operator.InputComponent ? { ...operator, InputComponent: DateFilterInput } : operator
);
